import React from "react";

/**
 * Renders a list cell as a single row that reveals a thin horizontal scrollbar
 * on hover or focus. Every value is in the DOM, so long lists cost real nodes.
 * This is the display used by every list-style column in BaseTableV3.
 *
 * Children must be `<li>` elements. Pass `separated={false}` for items that
 * already read as separate units, such as tag pills.
 */
export function ScrollColumn({ children, separated = true }) {
  const items = React.Children.toArray(children);

  return (
    <ul className="tw:m-0 tw:flex tw:list-none tw:gap-1 tw:overflow-x-hidden tw:p-0 tw:[scrollbar-width:thin] tw:[scrollbar-color:var(--color-text-muted)_var(--color-surface)] tw:hover:overflow-x-auto tw:focus-within:overflow-x-auto tw:[&::-webkit-scrollbar]:h-1 tw:[&::-webkit-scrollbar-track]:bg-card tw:[&::-webkit-scrollbar-thumb]:rounded-full tw:[&::-webkit-scrollbar-thumb]:bg-muted-foreground">
      {items.map((child, index) => {
        if (separated && index < items.length - 1) {
          return React.cloneElement(child, {
            key: child.key || index,
            children: (
              <>
                {child.props.children}
                {","}
              </>
            ),
          });
        }
        return child;
      })}
    </ul>
  );
}
